module.exports = __webpack_public_path__ + "img/orbit-homepage-background-mobile-s.ad1c8465.png";